// extracted by mini-css-extract-plugin
var _1 = "OverviewStyle-module__flex-columns___FV1PP";
var _2 = "OverviewStyle-module__flex-columns___FV1PP";
var _3 = "OverviewStyle-module__overview___lDpyR";
export { _1 as "flex-columns", _2 as "flexColumns", _3 as "overview" }
